<template>
    <div class="advancedSearch">
        <el-dialog v-loading="loading" :visible.sync="show" title="高级搜索" :maskClosable='false' :modal-append-to-body="false" custom-class="input-dialog" tableLayout="fixed">
            <div class="flex-out-div">
                <div class='viewLineDiv inputLine'>
                    <div class='title'>类型:</div>
                    <el-select class='input' v-model="searchType">
                        <el-option v-for='(selectItem) of typeList' :key="selectItem.key" :value="selectItem.key" :label="selectItem.value">
                        </el-option>
                    </el-select>
                </div>
                <div class='viewLineDiv inputLine'>
                    <div class='title'>标题:</div>
                    <el-input class='input' v-model='searchTitle' />
                </div>
                <!-- <div class='viewLineDiv inputLine'>
                    <div class='title'>内容:</div>
                    <el-input class='input' v-model='searchContent' />
                </div> -->
                <div class='viewLineDiv inputLine'>
                    <div class='title'>书籍名称:</div>
                    <el-input class='input' v-model='searchBookName' />
                </div>
                <div class='viewLineDiv inputLine'>
                    <div class='title'>分类号:</div>
                    <el-input class='input' v-model='searchCategoryNumber' />
                </div>
                <div class='viewLineDiv inputLine'>
                    <div class='title'>结构类型:</div>
                    <div class="structure-list">
                        <div class="structure-item" v-for="(item, index) of structureList" :key="index" :class="[searchStructure===item ? 'active' : '']" @click="searchStructure=(searchStructure===item) ? '' : item">{{item}}</div>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <el-button type="primary" @click='search'>搜索</el-button>
                <el-button type=""  @click="cancel">取消</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data () {
        return {
            show: false,
            searchType: '',
            typeList: [
                {
                    key: 'all',
                    value: '全部'
                },
                {
                    key: 'base',
                    value: '文献元数据'
                },
                {
                    key: 'schema',
                    value: '细粒度元数据'
                },
                {
                    key: 'pic',
                    value: '图表元数据'
                },
                {
                    key: 'person',
                    value: '人物'
                },
                {
                    key: 'org',
                    value: '机构'
                },
                {
                    key: 'event',
                    value: '事件'
                },
                {
                    key: 'geo',
                    value: '地理'
                },
                {
                    key: 'topic',
                    value: '专题'
                },
                {
                    key: 'zuopin',
                    value: '作品'
                },
                {
                    key: 'shiwu',
                    value: '实物'
                }
            ],
            searchTitle: '',
            searchContent: '',
            searchBookName: '',
            searchCategoryNumber: '',
            searchStructure: '',
            structureList: [
                '正文篇章',
                '附录',
                '辅文',
                '编委会',
                '封一后记',
                '序',
                '概述',
                '版权页',
                '封四',
                '封二'
            ]
        }
    },
    methods: {
        open () {
            this.show = true;
        },
        search () {
            let routeUrl = this.$router.resolve({
                name: 'searchList',
				query: {
					keyWord: this.searchTitle,
                    schemaType: this.searchType,
                    classification: this.searchCategoryNumber,
                    bookName: this.searchBookName,
                    structureType: this.searchStructure
				}
            })
            window.open(routeUrl.href, '_blank')
        },
        cancel () {
            this.show = false;
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.advancedSearch {

}

.flex-out-div {
    display: flex;
    flex-wrap: wrap;
}

.viewLineDiv {
    display: flex;
    align-items: center;
}

.inputLine {
    margin:0 100 * @uw 40 * @uh 20 * @uw;
    width: 700 * @uw;
    .title {
        width: 80 * @uw;
        flex-shrink: 0;
    }

    .input{
        width: 450 *@uw;
    }
    .must-icon {
        color: red;
        margin-left: 5 * @uw;
        font-size: 18 * @uw;
    }
    .location-icon {
        font-size: 20 * @uw;
        margin-left: 10 * @uw;
        cursor: pointer;
        color: rgb(15, 128, 193);
    }
    .info-icon {
        font-size: 16 * @uw;
        margin-left: 10 * @uw;
        color: rgb(217, 112, 37);
    }
    .structure-list {
        display: flex;
        align-items: center;

        .structure-item {
            color: black;
            padding: 5*@uh 10 * @uw 5 * @uh 10 * @uw;
            word-break: keep-all;
            cursor: pointer;

            &.active {
                background: rgb(141,94,26);
                color: white;
                border-radius: 3px;
            }
        }
    }
}

::v-deep .ant-input-number{
    width: 100%;
}

::v-deep .ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

::v-deep .ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

::v-deep .ant-upload.ant-upload-select-picture-card{
  width: 100 * @uw;
  height: 100 * @uh;
}

::v-deep .ant-upload-list{
  display: none;
}

::v-deep .input-dialog {
    // background-image: url('~@/assets/images/user/dialog-bg.png');
    // background-size: 100% 100%;
    // .el-dialog__header {
    //     padding:  5 * @uh 10 * @uw;
    //     // .el-dialog__title {
    //     //     font-size: 1rem;
    //     //     // color: #80CCFF;
    //     // }
    //     .el-dialog__headerbtn {
    //         top: 5 * @uh;
    //         font-size: 1rem;
    //         color: white;
    //         font-weight: 600;
    //     }
    // }
    .el-dialog__body {
        font-size: 14 * @cm;
        color: black;
        height: 520 * @uh;
        overflow-y: auto;
        overflow: hidden;
    }
}

::v-deep .el-dialog {
    margin-top: 100 *@uh !important;
    width: 850 * @uw;
}
/deep/ .el-input__suffix {
	display: flex;
	align-items: center;
	margin-right: -5px;
	border-radius: 5px;
	padding: 0px 10px 0px 10px;
	background: unset !important;
}
</style>
